export default __webpack_public_path__ + "3f3f96a69f013f59e26af6695bc7ec8c.png";